<template>
  <div class="rp-select is-small" v-if="styleType === 'normal'">
    <select v-on:change="updateValue($event.target.value)" v-bind:class="{ 'is-danger': status }">
      <option value="">&nbsp;--{{ t.selectOption }}--&nbsp;</option>
      <option v-for="(option, index) in inputData.dropdown" v-bind:key="index" v-bind:selected="value === option.value">
        {{ option.value }}
      </option>
    </select>

    <div class="validation-text" v-if="status === true">
      {{ t.pleaseSelectOption }}
    </div>
  </div>
  <div class="rp-material-form-dropdown" v-else-if="styleType === 'material'">
    <select
      class="rp-material-form-select"
      v-on:change="updateValue($event.target.value)"
      v-bind:class="{ 'is-danger': status }"
      required>
      <option value="">&nbsp;--{{ t.selectOption }}--&nbsp;</option>
      <option v-for="(option, index) in inputData.dropdown" v-bind:key="index" v-bind:selected="value === option.value">
        {{ option.value }}
      </option>
    </select>
    <span class="rp-material-form-select-highlight"></span>
    <span class="rp-material-form-select-bar"></span>
    <label class="rp-material-form-select-label">{{ t.country }}</label>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'DropdownInput',
  props: {
    value: String,
    styleType: {
      type: String,
      default: 'normal'
    },
    inputData: {
      type: Object,
      default: () => {
        return {
          type: 'dropdown',
          required: '0',
          placeholder: 'placeholder',
          dropdown: [
            {
              id: 1,
              value: 'Option1'
            },
            {
              id: 2,
              value: 'Option2'
            }
          ]
        }
      }
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          selectOption: 'Please select',
          pleaseSelectOption: 'Please select an option'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          selectOption: 'กรุณาเลือก',
          pleaseSelectOption: 'กรุณาเลือกรายการ'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          selectOption: 'Vui lòng chọn',
          pleaseSelectOption: 'Vui lòng chọn một mục'
        }
      }
    }
  },
  data () {
    return {
      status: false
    }
  },
  methods: {
    validateInput () {
      return this.validateInputProcess(this.value)
    },
    updateValue (value) {
      this.$emit('input', value)
      this.validateInputProcess(value)
    },
    validateInputProcess (value) {
      let result
      if ((value === '' || value === 'form-default-value') && this.inputData.required === '1') {
        this.status = true
        result = false
      } else {
        this.status = false
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.validation-text {
  color: red;
  font-size: 0.75em;
}

.rp-select {
  width: 100%;

  select {
    width: 100%;
  }
}

.rp-material-form-dropdown {
  .rp-material-form-select {
    border-bottom: 1px dashed #eee;

    &:valid {
      border-bottom: 1px dashed #eee;
    }

    &:focus {
      border-bottom: 1px solid rgb(33, 150, 243);
    }
  }
  .rp-material-form-select-bar {
    &::after,
    &::before {
      height: 1px;
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/form/DropdownInput.vue